var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size lg_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis maintit" }, [
            _c("i", [_vm._v("Category : " + _vm._s(this.categoryNm))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "view_cont" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid_wrap number-cell" },
                [
                  _c("div", { staticClass: "grid_total" }, [
                    _vm._v(
                      "\n\n                            Total Count \n                            "
                    ),
                    _c("em", [
                      _vm._v(_vm._s(_vm._f("numberFormat")(_vm.totalCount)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("toast-grid", {
                    key: _vm.gridKey,
                    ref: "GridId",
                    attrs: {
                      gridId: _vm.gridId,
                      data: _vm.gridData,
                      columns: _vm.columns,
                      options: _vm.options,
                      header: _vm.header,
                      pageOptions: _vm.pageOptions,
                      isTotalCount: false
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "paginate" },
                [
                  _c("sdl-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "total-rows": _vm.totalCount,
                      "per-page": _vm.perPage,
                      align: "center"
                    },
                    on: { change: _vm.search }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "gridtop_wrap_satisfaction" }, [
        _c("em", { staticClass: "txt_info" }, [
          _c("ul", [
            _c("li", [_vm._v("A : The Model lists are inaccurate\t")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "B : This Content is insufficient. I need more information."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("C : This content has the fault. It must be fixed.")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("D : I have a question about this content.")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32aa518c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32aa518c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/statisticsManager/KnowledgeCategoryPop.vue
// module id = rUEa
// module chunks = 0